import {
  Avatar,
  Box,
  Card,
  CardContent,
  GridLegacy as Grid,
  // Grid, // Grid not working as expected!
  ImageListItem,
  Stack,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { Layout } from "../../components/Layout";
import { ExternalLink } from "../../components/LinkedInProfileMaybe";
import { H1, P } from "../../components/Typography";
import {
  getBase64ImageSrc,
  RESOURCE_TYPE,
  ResourceChip,
  ResourceInfo,
} from "../Dashboard/ResourceMediaCard";
import { I18nContext } from "../I18n/I18nProvider";
import { useMsg } from "../../components/Msg/Msg";
import { generalMessages } from "../../components/messages";
import { routes } from "../../routes";
import { Loaders, QueryRenderer } from "../QM/QueryRenderer";
import { useMyQuery } from "../Authorization/reactQueryWrappers";
import { useParams, useSearchParams } from "react-router-dom";
import { Markdown } from "../../components/Markdown/Markdown";

const articleMock = {
  title: "Jak zlepšit své řečnické dovednosti pomocí knih",
  url: "https://hbr.org/2014/06/how-to-improve-your-public-speaking-skills",
  author: "Carmine Gallo",
  source: "Harvard Business Review",
  readTime: "6 min read", // TODO @jk - remove untranslated "read" at the end
  // date missing
  // authorImage missing
  // mainImage missing
  language: "cs",
  perex:
    "Zlepšení řečnických dovedností vyžaduje systematický přístup a pravidelné učení. Čtení knih o rétorice může být zásadním krokem k dosažení tohoto cíle.",
  summaryText:
    "Carmine Gallo v článku pro Harvard Business Review zdůrazňuje, že klíč k úspěšnému veřejnému mluvení spočívá v přípravě a praxi. Doporučuje, aby si řečníci osvojili několik základních principů: 1) Znalost tématu – důkladné porozumění tématu, o kterém máte mluvit, je základem jakéhokoli úspěšného projevu. 2) Empatie k publiku – pochopení potřeb a očekávání posluchačů vám pomůže přizpůsobit vaše sdělení. 3) Důležitost příběhů – vyprávění příběhů je jedním z nejefektivnějších způsobů, jak zaujmout a udržet pozornost posluchačů. 4) Cvičení – pravidelné trénování a opakovaná prezentace vašich projevů zvyšují vaše sebevědomí a zlepšují vaše schopnosti. Gallo také doporučuje čtení knih zaměřených na veřejné mluvení jako způsob, jak rozšířit své znalosti a získat nové perspektivy.",
  application:
    "Tento článek je užitečný pro můj cíl přečíst každý týden knihu o řečnických dovednostech, protože zdůrazňuje důležitost kontinuálního učení a praktikování. Získané poznatky z knih mi pomohou lépe strukturovat mé projevy a zlepšit můj přístup k publiku.",
  imagePrompt:
    "Osoba stojící před publikem, držící knihu a gestikulující během prezentace.",
  // TODO @jk just empty image with alt, replace with real image
  imageData:
    "PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMkMzRTUwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNiIgZmlsbD0id2hpdGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiPkltYWdlOiBPc29iYSBzdG9qw61jw60gcMWZZWQgcHVibGlrZW0sIGQuLi48L3RleHQ+PC9zdmc+",
};

const ArticleContentText = ({ text }) => {
  return (
    <P bigger sx={{ lineHeight: 1.5, mb: 2 }}>
      <Markdown text={text} />
      {/* {text} */}
    </P>
  );
};

// import FL_MAX_WIDTH ?
const ARTICLE_MAX_WIDTH = 1200;

export const Article = ({
  title,
  readTime,
  author,
  source,
  url,
  authorImage = null,
  date,
  mainImage = null,
  imageData,
  perex,
  summaryText,
  application,
  contents = [],
}) => {
  const { i18n } = useContext(I18nContext);
  const imageSrc = mainImage || getBase64ImageSrc(imageData);
  const hasSidebar = !!contents?.length;
  let [searchParams] = useSearchParams();
  const displayPerex = !!searchParams.get("displayPerex");

  return (
    <Box sx={{ maxWidth: ARTICLE_MAX_WIDTH, m: 0 }}>
      <Grid container spacing={2}>
        {/* Header Card (Full Width with Image on Right) TODO: PADDING LEFT NOT WORKING */}
        <Grid item xs={12}>
          <Card>
            <CardContent
              sx={{ display: "flex", gap: 2, alignItems: "stretch" }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ alignItems: "center" }}
                >
                  <ResourceChip resourceType={RESOURCE_TYPE.ARTICLE} />
                  <ResourceInfo
                    resourceType={RESOURCE_TYPE.ARTICLE}
                    duration={readTime}
                  />
                </Stack>
                <H1>{title}</H1>
                <Box sx={{ flex: 1 }} />
                <Grid container alignItems="center" spacing={1}>
                  {authorImage && (
                    <Grid item>
                      <Avatar alt={author} src={authorImage} />
                    </Grid>
                  )}
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                    }}
                  >
                    <P emphasized>{author}</P>
                    {!!date && (
                      <P>{i18n.formatLocal(i18n.parseUTCLocal(date), "PPP")}</P>
                    )}
                  </Grid>
                  <Grid item sx={{ marginLeft: "auto" }}>
                    <ExternalLink href={url} withEndIcon>
                      {source}
                    </ExternalLink>
                  </Grid>
                </Grid>
              </Box>
              {imageSrc && (
                <ImageListItem
                  sx={{
                    display: "flex",
                    alignItems: "stretch",
                    flex: 1,
                    maxWidth: "20%",
                    maxHeight: 200,
                  }}
                >
                  <img
                    src={imageSrc}
                    alt={title}
                    style={{ width: "100%", objectFit: "cover" }}
                  />
                </ImageListItem>
              )}
            </CardContent>
          </Card>
        </Grid>
        {/* </Grid>
        <Grid container spacing={2}> */}
        {/* Intro Text */}
        <Grid item xs={hasSidebar ? 8 : 12}>
          <Card>
            <CardContent>
              {!!perex && !!displayPerex && (
                <ArticleContentText text={perex} />
                // <P bigger sx={{ lineHeight: 1.5, mb: 2 }}> {perex} </P>
              )}
              <ArticleContentText text={summaryText} />
              {/* <P bigger sx={{ lineHeight: 1.5, mb: 2 }}> {summaryText} </P> */}
              <ArticleContentText text={application} />
              {/* <P bigger sx={{ lineHeight: 1.5, mb: 2 }}> {application} </P> */}
            </CardContent>
          </Card>
        </Grid>

        {/* Sidebar */}
        {hasSidebar && (
          <Grid item xs={4}>
            <Card>
              <CardContent>
                <Typography variant="h6">Obsah</Typography>
                {contents.map(({ label }) => (
                  <Typography variant="body2">{label}</Typography>
                ))}
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export const ArticlePage = () => {
  const generalMsg = useMsg({ dict: generalMessages });
  const { articleId } = useParams();
  const query = useMyQuery({
    queryKey: ["article", articleId],
    fetchDef: {
      url: `/api/latest/user-insight/article/${articleId}`,
    },
  });

  return (
    <Layout
      header={{
        back: {
          text: generalMsg("general.back"),
          href: routes.dashboard,
        },
      }}
    >
      <QueryRenderer
        query={query}
        loaderEl={<Loaders.CircularBlock spaced />}
        success={({ data }) => <Article {...data} />}
      />
    </Layout>
  );
};
